import { render, staticRenderFns } from "./swiperVideoList.vue?vue&type=template&id=2a6b1eba&scoped=true&"
import script from "./swiperVideoList.vue?vue&type=script&lang=js&"
export * from "./swiperVideoList.vue?vue&type=script&lang=js&"
import style0 from "./swiperVideoList.vue?vue&type=style&index=0&id=2a6b1eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b1eba",
  null
  
)

export default component.exports